import { Experiences as EC } from '@luxuryescapes/contract-svc-experience';

export function getDefaultTicketModes(ticketModes: Array<EC.TicketModeField>): Record<string, string> {
  let result: Record<string, string> = {};

  ticketModes.forEach((mode) => {
    if (mode.default) {
      result[mode.key] = mode.default;

      mode.options.forEach((option) => {
        if (option.key === mode.default && option.fields) {
          result = { ...result, ...getDefaultTicketModes(option.fields) };
        }
      });
    }
  });

  return result;
}

export function areRequiredTicketModesFilled(
  ticketModes: Array<EC.TicketModeField>,
  ticketModesMap: Record<string, string>,
): boolean {
  for (const mode of ticketModes) {
    if (mode.required && !ticketModesMap[mode.key]) {
      return false;
    }

    const selectedOption = mode.options.find((o) => o.key === ticketModesMap[mode.key]);
    if (selectedOption?.fields?.length && !areRequiredTicketModesFilled(selectedOption.fields, ticketModesMap)) {
      return false;
    }
  }
  return true;
}

export function getChainedValues(
  data: Record<string, string | undefined>,
  field: EC.TicketModeField,
  selectedKey: string | undefined,
): Record<string, string | undefined> {
  let newData = { ...data };
  newData[field.key] = selectedKey;

  field.options.forEach((option) => {
    const isSelected = option.key === selectedKey;
    option.fields?.forEach((childField) => {
      newData = { ...getChainedValues(newData, childField, isSelected ? childField.default : undefined) };
    });
  });

  return newData;
}
